import api from './api';

const COMM_PREFS_ENDPOINT =
  process.env.REACT_APP_COMM_PREFS_ENDPOINT || '/accounts/communication-preferences/';
const COMM_EVENTS_ENDPOINT =
  process.env.REACT_APP_COMM_EVENTS_ENDPOINT || '/communications/events/';
const NOTIFICATION_EMAIL_ENDPOINT =
  process.env.REACT_APP_NOTIFICATION_EMAIL_ENDPOINT || '/notifications/{id}/email/';

export const COMM_EVENT_KEYS = {
  DRIVER_ONBOARDING:
    process.env.REACT_APP_COMM_EVENT_DRIVER_ONBOARDING || 'driver_onboarding',
  VEHICLE_REGISTERED:
    process.env.REACT_APP_COMM_EVENT_VEHICLE_REGISTERED || 'vehicle_registered',
  TRIP_RECORDED:
    process.env.REACT_APP_COMM_EVENT_TRIP_RECORDED || 'trip_recorded',
  LEAVE_APPLIED:
    process.env.REACT_APP_COMM_EVENT_LEAVE_APPLIED || 'leave_applied',
};

const notificationEmailUrl = (id) =>
  NOTIFICATION_EMAIL_ENDPOINT.replace('{id}', String(id));

const communicationService = {
  getPreferences: () => api.get(COMM_PREFS_ENDPOINT).then((r) => r.data),
  updatePreferences: (payload) => api.patch(COMM_PREFS_ENDPOINT, payload).then((r) => r.data),
  dispatchEvent: (eventKey, payload = {}) =>
    api.post(COMM_EVENTS_ENDPOINT, { event_key: eventKey, ...payload }).then((r) => r.data),
  sendNotificationEmail: (id, payload = {}) =>
    api.post(notificationEmailUrl(id), payload).then((r) => r.data),
};

export const isNotificationEmailSyncEnabled =
  process.env.REACT_APP_NOTIFICATION_EMAIL_SYNC_ENABLED !== 'false';

export default communicationService;
